import React, { useState } from 'react';
import { IconButton } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import styles from '../styles';

interface TotalAmountProps {
    amount: number | string | React.ReactNode;
    currency: string;
    title?: string;
    style?: React.CSSProperties;
    breakdownItems?: TotalAmountBreakdownItem[];
}

interface TotalAmountBreakdownItem {
    label: string;
    amount: number | string | React.ReactNode;
    amountColor?: 'default' | 'negative' | 'positive' | 'main';
}

export default function TotalAmount(props: TotalAmountProps) {
    const classes = styles();
    const [isExpanded, setIsExpanded] = useState(false);

    function getAmountClassName(amountColor: TotalAmountBreakdownItem['amountColor']) {
        switch (amountColor) {
            case 'negative':
                return classes.totalAmountDropdownAmountNegative;
            case 'positive':
                return classes.totalAmountDropdownAmountPositive;
            case 'main':
                return classes.totalAmountDropdownAmountMain;
            default:
                return classes.totalAmountDropdownAmountDefault;
        }
    }

    const hasBreakdown = !!props.breakdownItems?.length;

    return (
        <div style={props.style}>
            <div
                className={`${classes.tabPriceContainer} ${classes.tabPriceAlignRight10}`}
                style={{ position: 'relative' }}
            >
                {props.title && <h4>{props.title}: </h4>}
                <div className={classes.totalAmountValueWrapper}>
                    <div style={{ marginBottom: 5 }}>
                        <span className={classes.currencyText}>{props.currency}</span>
                        <span className={classes.currencyAmount}>{props.amount}</span>
                    </div>
                    {hasBreakdown && (
                        <IconButton
                            size="small"
                            className={classes.totalAmountExpandButton}
                            onClick={() => setIsExpanded((prev) => !prev)}
                            color="primary"
                        >
                            {isExpanded ? (
                                <KeyboardArrowDownIcon fontSize="small" color="primary" />
                            ) : (
                                <KeyboardArrowUpIcon fontSize="small" color="primary" />
                            )}
                        </IconButton>
                    )}
                </div>

                {hasBreakdown && isExpanded && (
                    <div className={classes.totalAmountDropdown}>
                        {props.breakdownItems?.map((item, index) => (
                            <div
                                key={item.label}
                                className={`${classes.totalAmountDropdownRow} ${
                                    index === props.breakdownItems!.length - 1
                                        ? classes.totalAmountDropdownRowSummary
                                        : ''
                                }`}
                            >
                                <span className={classes.totalAmountDropdownLabel}>
                                    {item.label}
                                </span>
                                <span
                                    className={`${
                                        classes.totalAmountDropdownAmount
                                    } ${getAmountClassName(item.amountColor)}`}
                                >
                                    <span className={classes.totalAmountDropdownCurrency}>
                                        {props.currency} {item.amount}
                                    </span>
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
